import { Navigate, Route, Routes } from 'react-router-dom'

import { AccessRoleConstants } from '../../constants/AccessRoleConstants'
import { ProjectType } from '../../enum/ProjectType.enum'
import React from 'react'
import SFApexClassDetails from './SFApexClassDetails'
import SFApexClassesOverview from './SFApexClassesOverview'
import SFApexTriggerDetails from './SFApexTriggerDetails'
import SFApexTriggersOverview from './SFApexTriggersOverview'
import SFLicenseDetails from './SFLicenseDetails'
import SFLicensesOverview from './SFLicensesOverview'
import SFPermissionSetDetails from './SFPermissionSetDetails'
import SFPermissionSetsOverview from './SFPermissionSetsOverview'
import SFProfileDetails from './SFProfileDetails'
import SFProfilesOverview from './SFProfilesOverview'
import SFRoleDetails from './SFRoleDetails'
import SFRolesOverview from './SFRolesOverview'
import SFUsageGraphData from './SFUsageGraphData'
import SFUsersOverview from './SFUsersOverview'
import SalesforceAuditDashboard from './SalesforceAuditDashboard'
import SalesforceAuditLayout from './SalesforceAuditLayout'
import SecureComponent from '../../components/Layout/SecureComponent'
import { observer } from 'mobx-react-lite'

const SalesforceAudit: React.FC = () => {
  return (
    <Routes>
      <Route element={<SalesforceAuditLayout />}>
        <Route index element={<Navigate to='dashboard' />} />
        <Route path='dashboard' element={<SalesforceAuditDashboard />} />
        {/* <Route path='metadata' element={<MetaDataOverview />} /> */}
        <Route
          path='usageData/:salesforceApiName'
          element={<SFUsageGraphData />}
        />

        <Route
          path='metadata/apex-classes'
          element={<SFApexClassesOverview />}
        />
        <Route
          path='metadata/apex-classes/:id'
          element={<SFApexClassDetails />}
        />
        <Route
          path='metadata/apex-triggers'
          element={<SFApexTriggersOverview />}
        />
        <Route
          path='metadata/apex-triggers/:id'
          element={<SFApexTriggerDetails />}
        />
        <Route path='metadata/roles' element={<SFRolesOverview />} />
        <Route path='metadata/roles/:id' element={<SFRoleDetails />} />
        <Route path='metadata/profiles' element={<SFProfilesOverview />} />
        <Route path='metadata/profiles/:id' element={<SFProfileDetails />} />
        <Route
          path='metadata/permission-sets'
          element={<SFPermissionSetsOverview />}
        />
        <Route
          path='metadata/permission-sets/:id'
          element={<SFPermissionSetDetails />}
        />
        <Route path='users' element={<SFUsersOverview />} />
        {/* <Route path='users/:id' element={<UserDetails />} /> */}
        <Route path='licenses' element={<SFLicensesOverview />} />
        <Route path='licenses/:id' element={<SFLicenseDetails />} />
      </Route>
    </Routes>
  )
}

export default SecureComponent(
  observer(SalesforceAudit),
  AccessRoleConstants.MEMBER_LEVEL,
  ProjectType.FULL_STACK_ONLY
)
